"use client"

import { toImageSrc } from "@/lib/utils"
import type { WhyChooseUsItemProps } from "@/types/types"
import Image from "next/image"
import "./whyChooseUs.css"

export const WhyChooseUsItem = ({ item, className = "", isActive = false, onClick }: WhyChooseUsItemProps) => {
  const imageUrl = toImageSrc(item.image)

  return (
    <div
      onClick={onClick}
      className={`why-choose-us-item w-full flex flex-col items-center gap-0 pt-[1.75rem] pb-[2.9375rem] cursor-pointer rounded-lg duration-500 sm:w-full sm:max-w-[248px] h-[170px] bg-[#F7F8FA] ${isActive ? "why-choose-us-item-active" : ""
        } ${className}`}
    >
      <div className="relative w-[50px] h-[55px] sm:w-[50px] sm:h-[55px]">
        <Image src={imageUrl} alt={item.title} width={50} height={55} className="object-contain w-full h-full" />
      </div>
      <p className="text-center text-sm sm:text-base font-semibold sm:font-medium leading-[1.375rem] max-w-[160px] sm:max-w-[160px] text-[#333333] opacity-90 mt-2 sm:mt-[1.125rem]">
        {item.title}
      </p>
    </div>
  )
}
